const ko = {
  // Common
  ID_POPUP_BTN_CONFIRM: "확인",
  ID_POPUP_BTN_CANCEL: "취소",
  ID_POPUP_BTN_SAVE: "저장",
  ID_POPUP_BTN_DELETE: "삭제",
  ID_POPUP_BTN_REFUSAL: "거절",
  ID_POPUP_BTN_ACCEPT: "수락",

  ID_CHAT_REPORT_POPUP_TITLE: "채팅 신고",
  ID_CHAT_REPORT_POPUP_USER: "신고 대상",
  ID_CHAT_REPORT_POPUP_REASON: "신고 사유",
  ID_CHAT_REPORT_CONFIRM: "등록",

  ID_VOICE_CHAT_REPORT_POPUP_TITLE: "보이스 채팅 신고",
  ID_VOICE_CHAT_REPORT_POPUP_USER: "신고 대상",
  ID_VOICE_CHAT_REPORT_POPUP_REASON: "신고 사유",
  ID_VOICE_CHAT_REPORT_POPUP_RECORD: "채팅 녹음",
  ID_VOICE_CHAT_REPORT_POPUP_RECORD_BTN: "녹음",
  ID_VOICE_CHAT_REPORT_POPUP_PLAY_BTN: "재생",

  ID_CHAT_BLOCK_POPUP_TITLE: `{blockUser}님의 모든 채팅을 차단할까요?`,
  ID_CHAT_BLOCK_POPUP_CONFIRM: "차단",

  ID_POST_DECLARE_CONTENT: "신고 내용",
  ID_POST_DECLARE_REASON: "신고 사유를 선택해 주세요.",
  ID_POST_DECLARE_CONTENT_PLACEHOLDER: "내용을 입력해주세요.",
  ID_POST_DECLARE_ADD_FILE: "파일 첨부",
  ID_POST_DECLARE_TITLE: "게시글 신고",
  ID_POST_DECLARE_SELECT_ALL: "전체",

  ID_POST_DECLARE_SELECT_OBSCENT: "음란 및 선정적인 활동",
  ID_POST_DECLARE_SELECT_ABUSE: "지나친 욕설 및 타인 비하",
  ID_POST_DECLARE_SELECT_OUTFLOW: "개인정보유출",
  ID_POST_DECLARE_SELECT_ADVERTISI: "광고",
  ID_POST_DECLARE_SELECT_DOMINATION: "게시글 도배",
  ID_POST_DECLARE_SELECT_ETC: "기타 운영정책 위반 활동",

  ID_STUDIO_CREATE_NEW_PROJECT_FORMAT: `새 프로젝트{randomChar}`,
  ID_STUDIO_PROJECT_EDIT: "프로젝트 이름 변경",
  ID_STUDIO_PROJECT_EDIT_CONFIRM_BUTTON: "변경하기",

  ID_VOICE_CHAT_SETTING_TITLE: "보이스 채팅 설정",
  ID_VOICE_CHAT_SETTING_SPEAKER: "스피커",
  ID_VOICE_CHAT_SETTING_MIC: "마이크",
  ID_VOICE_CHAT_SETTING_TEST_BTN: "테스트",
  ID_VOICE_CHAT_SETTING_TEST_ING_BTN: "종료",
  ID_VOICE_CHAT_SETTING_TEST_PLAY_BTN: "재생중",
  ID_VOICE_CHAT_SETTING_SPEAKER_PLACEHOLDER: "스피커가 없습니다",
  ID_VOICE_CHAT_SETTING_MIC_PLACEHOLDER: "마이크가 없습니다",

  ID_POST_DECLARE_SUCSESS_TITLE: "신고 접수 되었습니다.",

  ID_WORLDPLAY_EXIT: "플레이를 종료하고 메인 랜드로 돌아갈까요?",

  ID_DEMO_PLAY_EXIT: "월드에서 나갈까요?",
  ID_DEMO_PLAY_EXIT_CONFIRM: "네",
  ID_DEMO_PLAY_EXIT_CANCEL: "아니오",

  ID_GROUND_SELECT_POPUP_TITLE: "Ground Select",

  ID_ASSET_ITEM_DELETE_POPUP_TITLE: "개의 항목을 삭제할까요?",

  ID_PRESET_TITLE: "마이 아바타 설정",
  ID_PRESET_DESCRIPTION: "마음에 드는 아바타를 선택해 보세요.\n아바타 선택 후 레드브릭 월드로 이동됩니다.",
  ID_PRESET_BUTTON: "시작하기",
  ID_PRESET_SKIP: "건너뛰기",

  ID_PRESET_CLOSE: "닫기",

  ID_POPUP_OUT: "나가기",
  ID_POPUP_KEEP: "계속하기",

  ID_CODE_ERROR_TITLE: "땡!",
  ID_CODE_ERROR_CONTENT: "코드를 잘못 입력했거나\n미션을 모두 수행하지 않았어요.",
  ID_CODE_COMPLETE: "축하합니다!",
  ID_CODE_COMPLETE_CONTENT: "{mission}을 완수했습니다.\n이름과 반을 입력하세요!",

  ID_NAME_ENTER: "이름 입력",
  ID_CLASS_ENTER: "반 입력",
  ID_CERTIFICATE_GETTING: "수료증 받기",

  ID_CERTIFICATE_TITLE: "수료증",
  ID_CERTIFICATE_CONTENT: "콘텐츠",
  ID_CERTIFICATE_DEC: "위와 같이 수료 사실을 증명합니다.",
  ID_CERTIFICATE_DOWNLOAD: "다운로드",
  ID_CERTIFICATE_PRINT: "인쇄",

  ID_PUBLISH_POPUP_TITLE_PLACEHOLDER: "제목을 입력해주세요.",
  ID_PUBLISH_POPUP_DESCRIPTION_PLACEHOLDER: "내용을 입력해주세요.",

  ID_INFORMATION_POPUP_TITLE: "📣 레드브릭 스튜디오 UI 개편 안내",
  ID_INFORMATION_POPUP_CONTENT:
    "더 좋은 창작 환경을 제공하기 위해 레드브릭 스튜디오 UI가 변경됩니다.\nOld버전과 New버전 모두 8월 25일 오후 12시(한국시간) 에 변경된 UI로 적용될 예정입니다.\n\n자세한 내용은 아래 WIKI 링크에서 확인하실 수 있습니다.",
  ID_INFORMATION_POPUP_LINK_BTN: "See More",
  ID_INFORMATION_POPUP_CLOSE_BTN: "Close",
};

export default ko;
